import React from 'react';

const RadioButtonGroup = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};

export default RadioButtonGroup;
